import { useCallback } from 'react';
import { releaseUploadQuiet } from '../upload/uploadQuiet';

export const useCrispChat = () => {

  const openCrispChat = useCallback(() => {
    // A support tap must not wait on an upload's first part.
    releaseUploadQuiet();
    if (typeof window === 'undefined' || !window.$crisp) return;
    window.$crisp.push(['do', 'chat:show']);
    window.$crisp.push(['do', 'chat:open']);
  }, []);

  const showCrispChat = useCallback(() => {
    if (typeof window === 'undefined' || !window.$crisp) return;
    window.$crisp.push(['do', 'chat:show']);
  }, []);

  const hideCrispChatToggle = useCallback(() => {
    if (typeof window === 'undefined' || !window.$crisp) return;
    window.$crisp.push(['do', 'chat:hide']);
  }, []);

  const closeCrispChat = useCallback(() => {
    if (typeof window === 'undefined' || !window.$crisp) return;
    window.$crisp.push(['do', 'chat:close']);
  }, []);

  const toggleCrispChat = useCallback(() => {
    if (typeof window === 'undefined' || !window.$crisp) return;
    window.$crisp.push(['do', 'chat:toggle']);
  }, []);

  return {
    openCrispChat,
    closeCrispChat,
    toggleCrispChat,
    hideCrispChatToggle,
    showCrispChat,
  };
};
